/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurementRequest } from './APIMeasurementRequest';
import {
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestFromJSONTyped,
    APIMeasurementRequestToJSON,
} from './APIMeasurementRequest';
import type { APIHumanReadableDurationRequest } from './APIHumanReadableDurationRequest';
import {
    APIHumanReadableDurationRequestFromJSON,
    APIHumanReadableDurationRequestFromJSONTyped,
    APIHumanReadableDurationRequestToJSON,
} from './APIHumanReadableDurationRequest';

/**
 * Special serializer that provides all data that should appear in an Article CSV Export.
 * @export
 * @interface APIArticleExportRequest
 */
export interface APIArticleExportRequest {
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleExportRequest
     */
    weight?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleExportRequest
     */
    length?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleExportRequest
     */
    height?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleExportRequest
     */
    width?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIArticleExportRequest
     */
    volume?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIHumanReadableDurationRequest}
     * @memberof APIArticleExportRequest
     */
    leadTime?: APIHumanReadableDurationRequest | null;
}

/**
 * Check if a given object implements the APIArticleExportRequest interface.
 */
export function instanceOfAPIArticleExportRequest(value: object): value is APIArticleExportRequest {
    return true;
}

export function APIArticleExportRequestFromJSON(json: any): APIArticleExportRequest {
    return APIArticleExportRequestFromJSONTyped(json, false);
}

export function APIArticleExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleExportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'weight': json['weight'] == null ? undefined : APIMeasurementRequestFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementRequestFromJSON(json['length']),
        'height': json['height'] == null ? undefined : APIMeasurementRequestFromJSON(json['height']),
        'width': json['width'] == null ? undefined : APIMeasurementRequestFromJSON(json['width']),
        'volume': json['volume'] == null ? undefined : APIMeasurementRequestFromJSON(json['volume']),
        'leadTime': json['lead_time'] == null ? undefined : APIHumanReadableDurationRequestFromJSON(json['lead_time']),
    };
}

export function APIArticleExportRequestToJSON(value?: APIArticleExportRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'weight': APIMeasurementRequestToJSON(value['weight']),
        'length': APIMeasurementRequestToJSON(value['length']),
        'height': APIMeasurementRequestToJSON(value['height']),
        'width': APIMeasurementRequestToJSON(value['width']),
        'volume': APIMeasurementRequestToJSON(value['volume']),
        'lead_time': APIHumanReadableDurationRequestToJSON(value['leadTime']),
    };
}

